import { useState } from "react";
import styles from "./DASS21Page.module.css";
import Button from "../../components/common/Button";

const ITEMS = [
  "Achei difícil me acalmar.",
  "Senti minha boca seca.",
  "Não consegui sentir nenhum sentimento positivo.",
  "Senti dificuldade para respirar.",
  "Achei difícil ter iniciativa para fazer as coisas.",
  "Tive tendência a reagir exageradamente a situações.",
  "Senti tremores.",
  "Senti que estava usando muita energia nervosa.",
  "Preocupei-me com situações em que poderia entrar em pânico.",
  "Senti que não tinha nada a esperar do futuro.",
  "Senti-me agitado(a).",
  "Achei difícil relaxar.",
  "Senti-me deprimido(a) e desanimado(a).",
  "Fui intolerante com qualquer coisa que me impedisse de continuar o que estava fazendo.",
  "Senti que estava prestes a entrar em pânico.",
  "Não consegui me entusiasmar com nada.",
  "Senti que não valia muito como pessoa.",
  "Senti-me irritável.",
  "Percebi as batidas do meu coração sem esforço físico.",
  "Senti medo sem motivo.",
  "Senti que a vida não tinha sentido.",
];

const DEPRESSION = [2, 4, 9, 12, 15, 16, 20];
const ANXIETY = [1, 3, 6, 8, 14, 18, 19];
const STRESS = [0, 5, 7, 10, 11, 13, 17];

export default function DASS21Page() {
  const [answers, setAnswers] = useState(Array(21).fill(null));
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (index, value) => {
    const updated = [...answers];
    updated[index] = value;
    setAnswers(updated);
  };

  const allAnswered = answers.every((a) => a !== null);

  const sum = (indexes) => indexes.reduce((acc, i) => acc + answers[i], 0);

  const depressionScore = sum(DEPRESSION);
  const anxietyScore = sum(ANXIETY);
  const stressScore = sum(STRESS);

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1>DASS-21</h1>
        <p>
          Esta escala avalia níveis recentes de sofrimento emocional,
          considerando sintomas de depressão, ansiedade e estresse. Ela não
          possui finalidade diagnóstica e deve ser interpretada de forma
          contextual.
        </p>
      </header>

      {!submitted && (
        <form className={styles.form}>
          {ITEMS.map((item, index) => (
            <div key={index} className={styles.item}>
              <p className={styles.statement}>{item}</p>

              <div className={styles.scale}>
                {[0, 1, 2, 3].map((value) => (
                  <label key={value} className={styles.option}>
                    <input
                      type="radio"
                      name={`item-${index}`}
                      value={value}
                      checked={answers[index] === value}
                      onChange={() => handleChange(index, value)}
                    />
                    {value}
                  </label>
                ))}
              </div>
            </div>
          ))}

          <Button
            disabled={!allAnswered}
            onClick={(e) => {
              e.preventDefault();
              setSubmitted(true);
            }}
          >
            Ver resultado
          </Button>
        </form>
      )}

      {submitted && (
        <section className={styles.result}>
          <h2>Resultado</h2>

          <div className={styles.scores}>
            <p>
              <strong>Depressão:</strong> {depressionScore}
            </p>
            <p>
              <strong>Ansiedade:</strong> {anxietyScore}
            </p>
            <p>
              <strong>Estresse:</strong> {stressScore}
            </p>
          </div>

          <p className={styles.interpretation}>
            Estes resultados descrevem níveis recentes de sofrimento emocional.
            Pontuações mais elevadas indicam maior intensidade de sintomas
            naquele domínio específico, mas não definem diagnósticos nem
            explicam, isoladamente, a história da pessoa.
          </p>

          <p className={styles.note}>
            Esses dados podem ser úteis para reflexão clínica e diálogo no
            processo terapêutico, especialmente quando integrados à formulação
            baseada em processos.
          </p>

          <Button onClick={() => setSubmitted(false)}>Refazer escala</Button>
        </section>
      )}
    </div>
  );
}
